import pollQuestionService from './pollQuestionService'

export default pollQuestionService



// WEBPACK FOOTER //
// ../src/services/pollQuestionService/index.js